import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import Common from "../../../helper/common";
import {
  ImageFolderEnum,
  respEnum,
  SliderDisplayTypeEnum,
  SliderTypeEnum,
  ToCSharpFormat,
} from "../../../constants/appConstant";
import { Formik } from "formik";
import { Icon } from "@iconify/react";
import {
  FormikInput,
  FormikSearchSelect,
  FormikSingleFileUpload,
  FormikSwitch,
} from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const FormikInitialValues = {
  banner: null,
  fromdate: null,
  tilldate: null,
  sportIds: [],
};

const formikValidation = yup.object({
  // banner title desc url

  // banner: yup
  //   .mixed()
  //   .required("Banner is required")
  //   .test("isValidBanner", "Only image files allowed", (value) => {
  //     if (!value) return false;

  //     if (typeof value === "string") {
  //       return /\.(jpg|jpeg|png|webp)$/i.test(value);
  //     }

  //     return value.type?.startsWith("image/");
  //   }),
  tilldate: yup
    .string()
    .nullable()
    .test("minutes-check", "Minutes must be 00 or 59", (value) => {
      if (!value) return true; // skip if empty

      // Extract ":MM" from the time portion
      const timeMatch = value.match(/(\d{1,2}):(\d{2})/);
      if (!timeMatch) return true; // skip if no time portion found

      const minutes = timeMatch[2]; // grab minutes from match
      return minutes === "00" || minutes === "59";
    }),

  fromdate: yup
    .string()
    .nullable()
    .test("minutes-check", "Minutes must be 00 or 59", (value) => {
      if (!value) return true; // skip if empty

      // Extract ":MM" from the time portion
      const timeMatch = value.match(/(\d{1,2}):(\d{2})/);
      if (!timeMatch) return true; // skip if no time portion found

      const minutes = timeMatch[2]; // grab minutes from match
      return minutes === "00" || minutes === "59";
    }),

  type: yup.string().required("Type is required"),
  displaytype:yup.string().required("Display Type is required"),
  // title: yup.string().trim().min(3).max(30).required("Title is Required"),
});

const AddSlider = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const [clubAccountList, setClubAccountList] = useState([]);
  const [sports, setSports] = useState([]);

  // const [fromdate, setFromDate] = useState("");

  // const [sliderType, setSliderType] = useState([]);
  // const types = [
  //   { id: null, name: "Select" },
  //   ...Common.Utility.enumToArray(SliderTypeEnum),
  // ];

  // setSliderType([
  //   { id: null, name: "Select" },
  //   ...Common.Utility.enumToArray(SliderTypeEnum),
  // ]);
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  function checkTime(dateTime) {
    return dateTime === "01 Jan 1970, 12:00 AM";
  }
  useEffect(() => {
    const fetchData = async () => {
      getClubAccount();
      getSports();
    };
    fetchData();
  }, []);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  // const handelSliderType = () => {

  //   setSliderType()
  // };
  const getClubAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetClubsDDL"
      );
      const data = [
        {
          id: null,
          name: "No Club",
        },
        ...response.data,
      ];
      setClubAccountList(data);
    });
  };

  // const preparePayload = (rawData) => {
  //   const banner = rawData.files?.find((f) => f.path)?.path || null;

  //   return {
  //     clubid: rawData.clubid,
  //     createdby: rawData.createdby,
  //     createdon: rawData.createdon,
  //     id: rawData.id,
  //     banner: banner,
  //     isactive: rawData.isactive,
  //     isdeleted: rawData.isdeleted,
  //     title: rawData.title,
  //     type: rawData.type,
  //     updatedby: rawData.updatedby,
  //     updatedon: rawData.updatedon,
  //   };
  // };
  const isValidDate = (value) => {
    const parsed = new Date(value);
    return parsed instanceof Date && !isNaN(parsed);
  };

  const onSubmitData = async (d, action) => {
    // console.log(d.banner, "before");
    debugger;

    // console.log(d.files?.[0].path, "141");

    const imagePath = d.files?.[0].path;
    if (imagePath) {
      d.banner = imagePath;
    }
    if (!d.banner) {
      toast.error(`Image is Required`);
      return;
    }

    // else {
    //   // d.banner = d.files?.[0].path;
    // }

    if (d.files && d.files.filter((item) => !item.imageUrl).length) {
      var uploadFilePathType = ImageFolderEnum.upload;
      d.banner = (
        await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
      )[0].photo;
      d.files = null;
    } else if (d.attachment) {
      d.banner = d.attachment;
    }
    // console.log(d.banner, "after");
    // console.log(d.files);

    let data = {
      ...d,
      id,
    };
    // data.banner = data.banner != null ? data.banner : null;
    data.fromdate = isValidDate(data.fromdate) ? data.fromdate : null;
    data.tilldate = isValidDate(data.tilldate) ? data.tilldate : null;
    data.refId = !data.refId ? null : data.refId;
    data.sliderroute =
      data.sliderroute == (null || "") ? null : data.sliderroute;

    data.url = data.url == (null || "") ? null : data.url;
    // data.fromdate = Common.moment(`${data.fromdate}`).format(ToCSharpFormat);

    // data.fromdate = Common.moment(`${d.fromdate}`).format(ToCSharpFormat);
    // data.fromdate = Common.moment(`${d.tilldate}`).format(ToCSharpFormat);

    if (data.fromdate >= data.tilldate && data.tilldate) {
      // Common.showToast("EndTime must be greater");

      toast.error("EndTime must be greater");
      return;
    }
    // console.log(data);

    // data.tilldate =
    //   data.tilldate === "01 Jan 1970, 12:00 AM" ? "-" : data.tilldate;
    // data.title = "hobby";

    // const cleanData = preparePayload(data);
    debugger;
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateSlider",
      // cleanData,
      data,
      // finalData,

      // { uploadedFiles },
      "POST"
    );

    // if (response.status === respEnum.Success) {
    //   Common.SweetAlert.alert(response.message, "success");
    //   setTimeout(() => {
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/Sliders", { replace: true });
      }
    }
    //     }
    //   });
    // }

    // if (d.banner != null) {
    //   // toast.error("Banner is required!");
    //   action.setSubmitting(true);
    //   return;
    // }
  };

  // const handleDateChange = (value) => {
  //   const humanDate = new Date(value).toLocaleDateString("en-US", {
  //     year: "numeric",
  //     month: "long",
  //     day: "numeric",
  //   });
  //   setFromDate(humanDate);
  // };

  // function toStandardDateFormat(dateString) {
  //   const date = new Date(dateString); // input like "07/09/2025 12:00 AM"
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   return `${year}-${month}-${day}`;
  // }

  const getDataInfo = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetSlider?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      // formikRef.current.setValues(response.data[0]);

      const item = response.data[0];

      debugger
      formikRef.current.setValues({
        ...item,
        // title: "test title from ref",
        fromdate: checkTime(item.fromdate) ? "datetime-local" : item.fromdate,
        //   ? "datetime-local"
        //   : toStandardDateFormat(item.fromdate),

        tilldate: checkTime(item.tilldate) ? "datetime-local" : item.tilldate,

        // tilldate: Common.moment(item.tilldate).format(ViewDateTimeFormat),
      });

      console.log(item);
      
      // console.log(toStandardDateFormat(response.data?.[0].fromdate), "log");
    }

    // const checkTime = time === "01 Jan 1970, 12:00 AM";
  };

  const getSports = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetSports"
      );
      const data = [
        // { id: null, name: "Select Sport" },
        ...(response?.data ?? []),
      ];

      setSports(data);
      //sportDataList = data;
    });
  };

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Slider
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <div className="flex flex-col gap-3">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"clubid"}
                          placeholder={"Select"}
                          label={"Clubs"}
                          data={clubAccountList}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="col-span-3">
                          <FormikSingleFileUpload
                            formikProps={formikProps}
                            title={"Banner"}
                            uploadMainTxt={"Upload Image"}
                            uploadTxt={"Max size 2 MB "}
                            name={"banner"}
                          />
                        </div>
                      </div>

                      {/* <div className="flex flex-col gap-2"> */}
                      <div className="flex flex-col gap-1">
                        <FormikInput
                          formikProps={formikProps}
                          name={"title"}
                          label={"Title"}
                          placeholder={"Type title"}
                          maxLength="50"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"url"}
                          label={"Url"}
                          placeholder={"Type Url"}
                          maxLength="50"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"sliderroute"}
                          label={"Slider Route"}
                          placeholder={"Type Slider Route"}
                          maxLength="50"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"type"}
                          placeholder={"Select"}
                          label={"Type"}
                          data={[
                            // { id: null, name: "Select" },
                            ...Common.Utility.enumToArray(SliderTypeEnum),
                          ]}
                          // onChange={handelSliderType}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"displaytype"}
                          placeholder={"Select"}
                          label={"Display Type"}
                          data={[
                            ...Common.Utility.enumToArray(SliderDisplayTypeEnum),
                          ]}
                        />
                       </div>

                      <div className="flex flex-col gap-2">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"sportIds"}
                          placeholder={"Select Sport"}
                          label={"Sport"}
                          data={sports}
                          isMulti
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"refId"}
                          label={"Ref ID"}
                          placeholder={"Type Ref ID"}
                          maxLength="50"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"desc"}
                          label={"Description"}
                          placeholder={"Type Description"}
                          maxLength="50"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"fromdate"}
                          // type={date}
                          // type={"date"}
                          label={"From Date"}
                          type={"datetime-local"}
                          min={Common.Utility.todayDatetime}
                          // onBlur={(event) => {
                          //   if (event.target.value) {
                          //     Common.Utility.handleBlur(
                          //       event.target.value,
                          //       "start Time",
                          //       true
                          //     );
                          //   }
                          // }}

                          // onChange={(value) => {
                          //   handleDateChange(value);
                          //   formikProps.setFieldValue("fromdate", value);
                          // }}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          // type={"date"}
                          name={"tilldate"}
                          label={"Till Date"}
                          type={"datetime-local"}
                          min={
                            formikProps.values.startDate ||
                            Common.Utility.todayDatetime
                          }
                          // onBlur={(event) => {
                          //   if (event.target.value) {
                          //     Common.Utility.handleBlur(
                          //       event.target.value,
                          //       "End Time",
                          //       true
                          //     );
                          //   }
                          // }}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikSwitch
                          formikProps={formikProps}
                          // disabled={id}   //toggle ko disabled karne k leye update karte wqt
                          name={"isactive"}
                          label={"Is Active"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddSlider;
